import Message from './components/message.js'
import './styles/less/index.less';

export default Message


// WEBPACK FOOTER //
// ./src/index.js